/**
 * language name to phoible language id, matches segmentsByLanguage
 */

/** if this is language from Phoible, get the URL to where the data can be found */
export function getPhoibleUrl(language: string): string | null {
  const id = languageToPhoible[language];
  if (id === undefined) {
    return null;
  }
  return "https://phoible.org/inventories/view/" + id.toString();
}

let languageToPhoible: Record<string, number> = {};

export function setLanguageToPhoible(data: Record<string, number>) {
  languageToPhoible = data;
}
